import 'reflect-metadata';
import { Expose } from "class-transformer";

export class SentinelaReportRequest {
  @Expose({ name: 'crop_type' })
  public cropType!: string;

  @Expose({ name: 'monitoring_year' })
  public monitoringYear!: number;

  @Expose({ name: 'owner_id' })
  public ownerId!: string | null;
}

export class RiskReportRequest {
  @Expose({ name: 'crop_type' })
  public cropType!: string;

  @Expose({ name: 'ref_year' })
  public refYear!: number;

  @Expose({ name: 'owner_id' })
  public ownerId!: string | null;
}
